import { Menu as MenuIcon } from "@mui/icons-material";
import {
  AppBar,
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom"; // If you're using react-router for navigation

const Header = () => {
  const [scrolling, setScrolling] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [color, setColor] = useState("#fff");
  const { t } = useTranslation();
  const green = "#248e8a";

  // Change header background color on scroll
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolling(true);
      } else {
        setScrolling(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        backgroundColor: scrolling ? green : "rgba(255, 255, 255, 0.2)", // Changes background color on scroll
        boxShadow: scrolling ? 0 : 3, // Adds shadow when scrolling
        transition: "background-color 0.3s ease, box-shadow 0.3s ease",
        padding: "10px 0",
        color: scrolling ? "white" : green,
      }}
    >
      <Toolbar>
        {/* Logo */}
        <Typography variant="h6" sx={{ flexGrow: 1 }}>
          <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>
            <img
              src={scrolling ? "logo.png" : "logo-vert.png"} // Replace with your logo path
              alt="Logo"
              style={{ height: 40 }} // Adjust the size of the logo
            />
          </Link>
        </Typography>

        {/* Desktop Navigation */}
        <Box sx={{ display: { xs: "none", sm: "flex" }, gap: 3 }}>
          <Button color="inherit" component={Link} to="/">
            {t("common:header.home")}
          </Button>
          <Button color="inherit" component={Link} to="/schedule">
            {t("common:header.schedule")}
          </Button>
          <Button color="inherit" component={Link} to="/teachers">
            {t("common:header.teachers")}
          </Button>
          <Button color="inherit" component={Link} to="/usefull">
            {t("common:header.usefull")}
          </Button>
          {/* <Button color="inherit" component={Link} to="/pictures">
            {t("common:header.pictures")}
          </Button> */}
        </Box>

        {/* Mobile Navigation (Hamburger Menu) */}
        <IconButton
          color="inherit"
          aria-label="menu"
          onClick={handleMenuClick}
          sx={{ display: { xs: "block", sm: "none" } }}
        >
          <MenuIcon />
        </IconButton>

        {/* Mobile Menu */}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          slotProps={{
            paper: {
              sx: {
                backgroundColor: "transparent",
                left: "auto!important",
                top: "auto!important",
                boxShadow: "none",
              },
            },
          }}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100vh",
            backgroundColor: green,
          }}
        >
          <MenuItem
            onClick={handleMenuClose}
            component={Link}
            to="/"
            sx={{ color: color, justifyContent: "center" }}
          >
            {t("common:header.home")}
          </MenuItem>
          <MenuItem
            onClick={handleMenuClose}
            component={Link}
            to="/schedule"
            sx={{ color: color, justifyContent: "center" }}
          >
            {t("common:header.schedule")}
          </MenuItem>
          <MenuItem
            onClick={handleMenuClose}
            component={Link}
            to="/teachers"
            sx={{ color: color, justifyContent: "center" }}
          >
            {t("common:header.teachers")}
          </MenuItem>
          <MenuItem
            onClick={handleMenuClose}
            component={Link}
            to="/usefull"
            sx={{ color: color, justifyContent: "center" }}
          >
            {t("common:header.usefull")}
          </MenuItem>
          {/* <MenuItem
            onClick={handleMenuClose}
            component={Link}
            to="/pictures"
            sx={{ color: color, justifyContent: "center" }}
          >
            {t("common:header.pictures")}
          </MenuItem> */}
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
